module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Light.2e6dc0b7.woff";